/**
 * Pages publiques à lien (Q10, Q35, Q68, Q172, §20-C) : aucune session, le
 * jeton de l'adresse est le seul droit, vérifié par le serveur.
 */
import { lazy } from 'react';
import type { ExternalRoute } from '../../app/route-types.js';

const QrRequestPage = lazy(() => import('./QrRequestPage.js').then((m) => ({ default: m.QrRequestPage })));
const RequestTrackingPage = lazy(() => import('./RequestTrackingPage.js').then((m) => ({ default: m.RequestTrackingPage })));
const InterventionTrackingPage = lazy(() => import('./InterventionTrackingPage.js').then((m) => ({ default: m.InterventionTrackingPage })));
const MachineTransferPage = lazy(() => import('./MachineTransferPage.js').then((m) => ({ default: m.MachineTransferPage })));
const CustomerIntakePage = lazy(() => import('./CustomerIntakePage.js').then((m) => ({ default: m.CustomerIntakePage })));
const QuoteSignPage = lazy(() => import('./QuoteSignPage.js').then((m) => ({ default: m.QuoteSignPage })));
const VisitConfirmPage = lazy(() => import('./VisitConfirmPage.js').then((m) => ({ default: m.VisitConfirmPage })));
const FeedbackPage = lazy(() => import('./FeedbackPage.js').then((m) => ({ default: m.FeedbackPage })));
const GdprRequestPage = lazy(() => import('./GdprRequestPage.js').then((m) => ({ default: m.GdprRequestPage })));
const SupplierPortalPage = lazy(() => import('./SupplierPortalPage.js').then((m) => ({ default: m.SupplierPortalPage })));

export const publicRoutes: ExternalRoute[] = [
  { path: '/qr/:token', element: <QrRequestPage /> },
  { path: '/suivi-demande/:token', element: <RequestTrackingPage /> },
  { path: '/suivi/:token', element: <InterventionTrackingPage /> },
  { path: '/transfert-machine/:token', element: <MachineTransferPage /> },
  { path: '/fiche-client/:token', element: <CustomerIntakePage /> },
  { path: '/signature-devis', element: <QuoteSignPage /> },
  { path: '/visite', element: <VisitConfirmPage /> },
  { path: '/avis', element: <FeedbackPage /> },
  { path: '/rgpd', element: <GdprRequestPage /> },
  // `/fournisseur` (portail public d'un fournisseur), à ne pas confondre avec
  // `/fournisseurs` (les achats, dans l'application interne).
  { path: '/fournisseur', element: <SupplierPortalPage /> },
];
